



















import Vue from 'vue';

export default Vue.extend({
  methods: {
    handleGetStarted(): void {
      this.$router.push({ path: 'flexOptions/aligncontent' });
    },
  },
});
